"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maskPIIData = exports.getUserInfo = exports.consoleCss = exports.postProps = exports.retry = exports.intervalUntil = exports.getCdnPath = void 0;

var _uxcore = require("@ux/uxcore2");

var _constants = require("./constants");

var getCdnPath = function getCdnPath(env) {
  var envPrefix = {
    prod: '',
    dev: "".concat(_constants.ENV_STRINGS.dev, "-"),
    test: "".concat(_constants.ENV_STRINGS.test, "-")
  }[env];
  return "//img1.".concat(envPrefix, "wsimg.com/dc-assets/help-chat");
};

exports.getCdnPath = getCdnPath;

var intervalUntil = function intervalUntil(conditionCheckFunction, delayInMs) {
  return regeneratorRuntime.async(function intervalUntil$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return regeneratorRuntime.awrap(new Promise(function (resolve) {
            var interval = setInterval(function () {
              if (conditionCheckFunction()) {
                resolve();
                clearInterval(interval);
              }
            }, delayInMs);
          }));

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  });
};

exports.intervalUntil = intervalUntil;

var retry = function retry(fn, retries, interval) {
  var result;
  return regeneratorRuntime.async(function retry$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return regeneratorRuntime.awrap(fn());

        case 3:
          result = _context2.sent;
          return _context2.abrupt("return", result);

        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);

          if (!retries) {
            _context2.next = 13;
            break;
          }

          _context2.next = 12;
          return regeneratorRuntime.awrap(new Promise(function (r) {
            return setTimeout(r, interval);
          }));

        case 12:
          return _context2.abrupt("return", retry(fn, retries - 1, interval));

        case 13:
          throw new Error("Max retries reached error: ".concat(_context2.t0));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, [[0, 7]]);
};

exports.retry = retry;
var postProps = {
  method: 'POST',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
};
exports.postProps = postProps;

var consoleCss = function consoleCss(bgColor, textColor) {
  return "display: block; background: ".concat(bgColor, "; padding: 5px; color: ").concat(textColor, "; font-weight: 700; font-size: 16px;");
};

exports.consoleCss = consoleCss;

var getUserInfo = function getUserInfo() {
  var infoIdp = _uxcore.utils.cookie.get('info_idp'); // eslint-disable-next-line camelcase


  var _ref = infoIdp && JSON.parse(infoIdp) || {},
      info_shopperId = _ref.info_shopperId,
      firstname = _ref.firstname,
      lastname = _ref.lastname;

  var visitor = _uxcore.utils.cookie.get('visitor');

  var pathway = _uxcore.utils.cookie.get('pathway');

  var visitorId = visitor && visitor.length > 4 ? visitor.split('=')[1] : '';
  return {
    // eslint-disable-next-line camelcase
    shopperId: info_shopperId || '',
    visitorId: visitorId,
    firstName: firstname || '',
    lastName: lastname || '',
    pathway: pathway || '',
    socialId: visitorId ? visitorId + '|' + pathway : ''
  };
};

exports.getUserInfo = getUserInfo;

var maskPIIData = function maskPIIData(text) {
  if (!text) return text;
  return text.replace(/\d{3}/g, 'XXX').replace(/XXX\d{1}/g, 'XXXX').replace(/\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/, "XXXXXXX@XXXX.XXX");
};

exports.maskPIIData = maskPIIData;